// extracted by mini-css-extract-plugin
export var component = "SignpostParagraph-module--component--300ca";
export var fadePop = "SignpostParagraph-module--fade-pop--10c40";
export var grid = "SignpostParagraph-module--grid--4e698";
export var growHeightIn = "SignpostParagraph-module--grow-height-in--f0275";